import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Typography } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteGroupFromRole } from "../../../actions";
import { errorAction, types as at } from "@authzsvc/api-lib";
import { showErrorNotification } from "../../../utils";

const { Text } = Typography;

const GroupRow = ({ group, applicationid, roleid, actions }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleDelete = async () => {
    setModalVisible(false);
    const resp = await actions.deleteGroupFromRole(
      applicationid,
      roleid,
      group.id,
    );
    if (resp.type === errorAction(at.DELETE_GROUP_FROM_ROLE)) {
      showErrorNotification(resp.payload.title, resp.payload.data.message);
    }
  };

  return (
    <>
      <Button
        id="unlinkGroupButton"
        variant="outlined"
        danger
        icon={<DeleteOutlined />}
        onClick={() => setModalVisible(true)}
      />
      <Modal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleDelete}
        okText="Unlink"
        cancelText="Cancel"
        cancelButtonProps={{
          onClick: () => setModalVisible(false),
          type: "default",
          color: "gray",
          variant: "filled",
        }}
        okButtonProps={{ danger: true, color: "red", variant: "filled" }}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <ExclamationCircleOutlined
              style={{ fontSize: 24, color: "#faad14" }}
            />
            <Text strong>Unlink Group: {group.displayName}?</Text>
          </div>
        }
        width={500}
        centered
        closable
      >
        <Text>
          Are you sure you want to unlink <strong>{group.displayName}</strong>?
        </Text>
      </Modal>
    </>
  );
};

GroupRow.propTypes = {
  group: PropTypes.object.isRequired,
  applicationid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  roleid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  actions: PropTypes.shape({
    deleteGroupFromRole: PropTypes.func,
  }),
};

export default connect(null, (dispatch) => ({
  actions: bindActionCreators({ deleteGroupFromRole }, dispatch),
}))(GroupRow);
